import moment from 'utils/momentInstanse'
import orderBy from 'lodash/orderBy'

export const mappingDataForConsamptionCharts = (sData = []) => {
  const _sorterServerData = orderBy(sData, 'timestamp', 'asc')
  const _data = _sorterServerData?.reduce(
    (result, i) => {
      const datetime = moment
        .unix(i.timestamp)
        .format('YYYY-MM-DD[T]HH:mm:ss[.000Z]')

      result.xAxisData.push(datetime)
      result.yAxisData.push(i.consumption)
      result.yAxisTemperature.push(i.temperature)
      return result
    },
    {
      xAxisData: [],
      yAxisData: [],
      yAxisTemperature: [],
    }
  )

  return [_data.xAxisData, _data.yAxisData, _data.yAxisTemperature]
}
